export default "__VITE_ASSET__CnZdRkrC__"